import { isPlainObject } from 'lodash-es';
export function isObject(obj) {
    return isPlainObject(obj);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwaW5nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi91dGlscy90eXBpbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLFdBQVcsQ0FBQTtBQUV6QyxNQUFNLFVBQVUsUUFBUSxDQUFDLEdBQWE7SUFDcEMsT0FBTyxhQUFhLENBQUMsR0FBRyxDQUFDLENBQUE7QUFDM0IsQ0FBQyJ9